import { render, staticRenderFns } from "./Counts.vue?vue&type=template&id=3526c8e0&scoped=true"
import script from "./Counts.vue?vue&type=script&lang=js"
export * from "./Counts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3526c8e0",
  null
  
)

export default component.exports